/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data payload for \'communication.content_ready\': fetch the entry\'s content again, it is cached now.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationContentReadyData { 
    entryId: number;
    patientId: number | null;
}
export const CommunicationContentReadyData_entryId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationContentReadyData_patientId_Validators: ValidatorFn[] =
    [  Validators.required, ];


